class Pagination extends HTMLElement {
  constructor() {
    super();

    const paginateContent = document.getElementById("Paginate-Content");
    if (!paginateContent) return;

    this.updateUrl = true;

    this.sectionId = paginateContent.dataset.section;
    this.contentListWrapper = paginateContent.querySelector(".content-list");
    if (!this.sectionId || !this.contentListWrapper) return;

    this.bindListener();
  }

  bindListener() {
    this.querySelectorAll(".pagination-item").forEach((item) => {
      item.addEventListener("click", this.handleEvent.bind(this));
    });
  }

  handleEvent(event = null) {
    if (event) event.preventDefault();

    const url = event?.currentTarget?.href;
    if (!url) return;

    const urlObj = new URL(url, window.location.origin);
    const queryString = urlObj.search ? urlObj.search.substring(1) : "";

    this.fetchContent(queryString);
  }

  /**
   * Fetch novi sadržaj (radi i za page 1 kad je queryString prazan)
   * @param {string} queryString
   */
  fetchContent(queryString = "") {
    this.startLoading();

    const fetchUrl = queryString
      ? `${window.location.pathname}?section_id=${this.sectionId}&${queryString}`
      : `${window.location.pathname}?section_id=${this.sectionId}`;

    fetch(fetchUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }
        return response.text();
      })
      .then((responseText) => {
        if (responseText) this.render(responseText);

        // Clean URL u address baru — koristi URLSearchParams (nema substring bug)
        if (this.updateUrl) {
          let cleanQuery = queryString;

          try {
            const params = new URLSearchParams(cleanQuery);
            params.delete("section_id");
            if (params.get("page") === "1") params.delete("page");
            cleanQuery = params.toString();
          } catch (e) {}

          window.history.replaceState(
            {},
            "",
            cleanQuery ? `${window.location.pathname}?${cleanQuery}` : window.location.pathname
          );
        }
      })
      .catch(() => {
        webvista.popToast(window["accessibilityStrings"]["unknownError"], "error");
      })
      .finally(() => {
        this.endLoading();
      });
  }

  render(htmlText) {
    if (!htmlText) return;

    const sourceDom = new DOMParser().parseFromString(htmlText, "text/html");
    const sourceContentDom = this.getSourceContent(sourceDom);
    if (!sourceContentDom) return;

    this.renderContent(sourceContentDom);
    this.renderPagination(sourceDom);

    if (typeof initializeScrollAnimationTrigger === "function") {
      initializeScrollAnimationTrigger(this.contentListWrapper);
    }

    webvista.initLazyImages();
    webvista.initToolTips();
  }

  getSourceContent(sourceDom) {
    if (!sourceDom) return;

    const contentList = sourceDom.querySelector("#Paginate-Content .content-list");
    if (contentList) {
      contentList
        .querySelectorAll(".grid-item.collection-advertise")
        .forEach((el) => el.remove());
    }
    return contentList;
  }

  renderContent(sourceContentDom) {
    webvista.scrollElementToHeaderBottom(this.contentListWrapper, 32);
    this.contentListWrapper.innerHTML = sourceContentDom.innerHTML;
  }

  renderPagination(sourceDom) {
    const sourcePaginationContainer = sourceDom.querySelector(".pagination-container");
    const targetPaginationContainer = this.closest(".pagination-container");

    if (sourcePaginationContainer && targetPaginationContainer) {
      targetPaginationContainer.innerHTML = sourcePaginationContainer.innerHTML;
    }
  }

  startLoading() {
    this.contentListWrapper.classList.add("loading");
  }

  endLoading() {
    this.contentListWrapper.classList.remove("loading");
  }
}

customElements.define("pagination-page", Pagination);

/**
 * Load more paginator
 */
class PaginationMore extends Pagination {
  constructor() {
    super();
    this.updateUrl = false;
  }

  bindListener() {
    this.button = this.querySelector(".pagination-more-button");
    this.boundClickHandler = this.handleEvent.bind(this);
    if (this.button) this.button.addEventListener("click", this.boundClickHandler);
  }

  renderContent(sourceContentDom) {
    const fragment = document.createDocumentFragment();
    Array.from(sourceContentDom.childNodes).forEach((node) => fragment.appendChild(node));
    this.contentListWrapper.appendChild(fragment);
  }

  startLoading() {
    super.startLoading();
    this.button.classList.add("loading");
    this.button.setAttribute("aria-disabled", true);
  }

  endLoading() {
    super.endLoading();
    this.button.classList.remove("loading");
    this.button.removeAttribute("aria-disabled");
  }
}

customElements.define("pagination-more", PaginationMore);

class PaginationScrollMore extends Pagination {
  constructor() {
    super();
    this.updateUrl = false;
  }

  bindListener() {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.handleEvent();
            observer.disconnect();
          }
        });
      },
      { rootMargin: "0px 0px 200px 0px" }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  handleEvent(event = null) {
    const url = this.getAttribute("data-url");
    if (!url) return;

    const urlObj = new URL(url, window.location.origin);
    const queryString = urlObj.search ? urlObj.search.substring(1) : "";

    this.fetchContent(queryString);
  }

  renderContent(sourceContentDom) {
    const fragment = document.createDocumentFragment();
    Array.from(sourceContentDom.childNodes).forEach((node) => fragment.appendChild(node));
    this.contentListWrapper.appendChild(fragment);
  }
}

customElements.define("pagination-scroll-more", PaginationScrollMore);
